import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import ContentCardView from './content-card-view';
class ContentCard extends Component {
  static propTypes = {
    isLoading: PropTypes.bool
  };

  static defaultProps = {
    isLoading: false
  };

  render() {
    if (this.props.permissionNeeded && !this.props.auth.permissions[this.props.permissionNeeded]) return null;
    return <ContentCardView {...this.props} />
  }

}

const mapStateToProps = (state) => ({
  auth: state.auth
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ContentCard);



// WEBPACK FOOTER //
// ./src/components/common/content-card/content-card.js